module.exports = __webpack_public_path__ + "img/bg_sev_c.62560def.jpg";